import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';
import { isLineSchedulingFeatureEnabledSelector } from 'store/selectors/featureFlagSelectors';

const getSchedule = (state: IGlobalReduxStore) => state.schedule;

const isLineSchedulingSelector = createSelector(
  getSchedule,
  isLineSchedulingFeatureEnabledSelector,
  (scheduleState, isLineSchedulingEnabled) =>
    isLineSchedulingEnabled && scheduleState.isLineScheduling,
);

export default isLineSchedulingSelector;
